export default __webpack_public_path__ + "static/media/logo_nobre-loading.7f19fbeb.png";